module.exports = __webpack_public_path__ + "img/dsci0063.a2d22bdb.jpg";